// extracted by mini-css-extract-plugin
export var container = "brand-social-card-module--container--Hhdmt";
export var hoverLayer = "brand-social-card-module--hover-layer--A8-RJ";
export var list = "brand-social-card-module--list--oNvHU";
export var logoImageBox = "brand-social-card-module--logo-image-box--5WCoc";
export var mainImageBox = "brand-social-card-module--main-image-box--TPbC9";
export var mainRatio = "brand-social-card-module--main-ratio--gaLr5";
export var mobile = "brand-social-card-module--mobile--OvXQY";